import type { JSX } from 'react';

import { Button, Separator } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { useFormFooter } from './hooks/useFormFooter';

export function FormFooter(): JSX.Element {
	const { data, actions } = useFormFooter();

	return (
		<Box
			id="form-footer-box"
			sx={{
				zIndex: 10,
				position: 'sticky',
				bottom: 0,
				width: '100%',
				paddingX: ['16px', '48px'],
				backgroundColor: 'background',
				textAlign: 'right',
			}}
		>
			<Separator className="!m-0" />
			<div className="container py-4">
				<Button
					className="w-40"
					variant="primary"
					disabled={data.isSubmitting}
					size="small"
					onClick={actions.handleSubmit}
					data-qa="edit-save-button"
				>
					<Translate value="corgi.petition.edit.save" />
				</Button>
			</div>
		</Box>
	);
}
